// extracted by mini-css-extract-plugin
export default {"wrapper":"winnersTemplate_wrapper__B-s7z"};